import React, { useCallback, useEffect, useState } from 'react';

import { ResponsibleApi, useApplicationState } from '@atlas/core';
import { HeaderTitle, Label } from '@atlas/ui';

import RealityCheckChips from 'components/ClientProfile/ResponsibleGaming/RealityCheck/RealityCheckChips';

const RealityCheckOld = () => {
  const { authenticated } = useApplicationState();
  const [selectedPeriod, setSelectedPeriod] = useState();

  useEffect(() => {
    if (!authenticated) return;
    ResponsibleApi.getRealityCheckSettings().then(({ period: fetchedPeriod }) =>
      setSelectedPeriod(fetchedPeriod),
    );
  }, [authenticated]);

  const setActivePeriod = useCallback(
    activePeriod => {
      setSelectedPeriod(activePeriod);

      ResponsibleApi.setRealityCheckSettings({ period: activePeriod }).then(
        ({ period: fetchedPeriod }) => {
          if (fetchedPeriod !== activePeriod) {
            setSelectedPeriod(fetchedPeriod);
          }
        },
      );
    },
    [setSelectedPeriod],
  );

  return (
    <div className="reality-check-container">
      <div className="title-wrapper">
        <HeaderTitle className="sub-text block-medium" title="about_reality_check" />
      </div>
      <Label
        className="title-small-normal-text desc-reality-check"
        message="reality_check_message"
      />
      <div className="title-wrapper">
        <HeaderTitle className="sub-text block-medium" title="reality_check_select_period" />
      </div>
      <RealityCheckChips selectedPeriod={selectedPeriod} setSelectedPeriod={setActivePeriod} />
    </div>
  );
};

export default RealityCheckOld;
